import client from '../../client';

const endpoint = 'v2/classifier/classifications'


/**
 * Create a new classification with the given data for the request.
 * For more information please read the docs in the backend.
 *
 * @param {Object} data
 */
export function create(data) {
  return client.post(endpoint, data).then(({ data }) => data)
}

/**
 * Get all the classifications with the given params.
 *
 * @param {Object} params
 */
export function getAll(params) {
  return client.get(endpoint, { params }).then(({ data }) => data)
}


/**
 * Merge some classifications. For more information please read the docs in the api.
 * @param {Object} data
 */
export function merge(data) {
  return client.post(`${endpoint}/merge`, data).then(({ data }) => data)
}


export default {
  create,
  getAll,
  merge
}
